export const sagasDashboardInteractions = [];
